// ---------------------------------------------------------------------------
// compute-span — pure cell-snap math for drag-resize
// ---------------------------------------------------------------------------
//
// Given the span at pointer-down and how far the pointer has travelled along the
// axis, return the new integer span snapped to whole grid cells. Adding one span
// unit consumes one track PLUS one gap, so `step = cellPx + gapPx` and the cell
// delta is `round(deltaPx / step)`. Sibling of compute-drop-index.js.

/**
 * @param {number} startSpan - span at pointerdown (integer ≥ min).
 * @param {number} deltaPx - pointer travel along the axis (px; negative shrinks).
 * @param {number} cellPx - one grid track size (column width or row height, px).
 * @param {number} gapPx - grid gap along the axis (px).
 * @param {number} min - minimum span (1).
 * @param {number} max - maximum span (per breakpoint; callers pass an effective max).
 * @returns {number} new integer span, clamped to [min, max].
 */
export function computeSpan(startSpan, deltaPx, cellPx, gapPx, min, max) {
  const step = cellPx + gapPx;
  if (!(step > 0)) return startSpan; // degenerate geometry (e.g. jsdom) → no change
  const deltaCells = Math.round(deltaPx / step);
  return Math.min(max, Math.max(min, startSpan + deltaCells));
}
